// extracted by mini-css-extract-plugin
export var CardInfoBody = "post-module--CardInfoBody--b3012";
export var CardInfoTitle = "post-module--CardInfoTitle--aad5d";
export var author = "post-module--author--42cc7";
export var authorContainer = "post-module--authorContainer--73469";
export var bottom = "post-module--bottom--c829a";
export var cardInfo = "post-module--cardInfo--fd6ba";
export var cards = "post-module--cards--7b817";
export var content = "post-module--content--6da23";
export var dashedBorder = "post-module--dashedBorder--f74e3";
export var date = "post-module--date--1e2ff";
export var dateContainer = "post-module--dateContainer--cc831";
export var info = "post-module--info--99460";
export var infoContainer = "post-module--infoContainer--d1224";
export var info__image = "post-module--info__image--08dcc";
export var inner = "post-module--inner--8e079";
export var newsletter = "post-module--newsletter--4022c";
export var newsletter__content = "post-module--newsletter__content--4ad3e";
export var newsletter__title = "post-module--newsletter__title--619f5";
export var post = "post-module--post--3d2ce";
export var profile = "post-module--profile--c16ee";
export var related = "post-module--related--9b6cb";
export var separator = "post-module--separator--310e6";
export var socials = "post-module--socials--4a8db";
export var tag = "post-module--tag--16501";
export var title = "post-module--title--a219d";
export var xButton = "post-module--xButton--a8638";